<template>
  <main>
    <div class="tile-selector" data-vv-name="deviceData.model">
      <div>
        <h4 class="tile-selector--header">
          {{ $t('step3HoneywellPage.headline') }}
        </h4>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-6 device-tile-col">
          <div
            tabindex="0"
            id="resideo__tile"
            @click="handleSelect('honeywell')"
            @keyup.enter="handleSelect('honeywell')"
            :class="['device-tile', { 'tile-selected': appSelected === 'honeywell' }]"
            :style="appSelected === 'honeywell' ? { borderColor: theme.primaryColor || '#016699' } : {}"
          >
            <div class="device-tile-content">
              <img
                src="@/assets/devices/honeywell/smartHome.png"
                alt="Resideo Smart Home Logo"
              />
              <h4>{{ $t('step3HoneywellTileLabels.honeywell') }}</h4>
            </div>
          </div>
        </div>
        <div class="col-lg-6 device-tile-col">
          <div
            tabindex="0"
            id="tcc__tile"
            @click="handleSelect('honeywellTcc')"
            @keyup.enter="handleSelect('honeywellTcc')"
            :class="['device-tile', { 'tile-selected': appSelected === 'honeywellTcc' }]"
            :style="appSelected === 'honeywellTcc' ? { borderColor: theme.primaryColor || '#016699' } : {}"
          >
            <div class="device-tile-content">
              <img
                src="@/assets/devices/honeywell/tcc.png"
                alt="Total Connect Comfort Logo"
              />
              <h4>{{ $t('step3HoneywellTileLabels.honeywellTCC') }}</h4>
            </div>
          </div>
        </div>
        <div class="col-lg-6 device-tile-col">
          <div
            tabindex="0"
            id="first-alert__tile"
            @click="handleSelect('honeywellFirstAlert')"
            @keyup.enter="handleSelect('honeywellFirstAlert')"
            :class="['device-tile', { 'tile-selected': appSelected === 'honeywellFirstAlert' }]"
            :style="appSelected === 'honeywellFirstAlert' ? { borderColor: theme.primaryColor || '#016699' } : {}"
          >
            <div class="device-tile-content">
              <img
                src="@/assets/devices/honeywell/firstAlert.png"
                alt="First Alert by Resideo Logo"
              />
              <h4>{{ $t('step3HoneywellTileLabels.honeywellFirstAlert') }}</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 27px">
        <p class="tile-selector--help">
          <a :href="helpLink" target="_blank" :style="{ color: theme.primaryColor }">{{ $t('step3HoneywellPage.helpLink') }}</a>
        </p>
      </div>
      <div v-if="appSelected" class="app-login-info__container">
        <div class="app-login-info__text">
          <p v-if="appSelected === 'honeywellTcc'" v-html="$t('step3OauthDeviceHoneywell')"></p>
          <template v-else>
            <p>
              {{ $t(appSelected === 'honeywellFirstAlert' ? 'step3HoneywellFirstAlertEnrollmentInstructions' : 'step3HoneywellResideoEnrollmentInstructions') }}
              <span
                :style="{
                  color: theme.primaryColor || '#016699',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }"
                @click="showModalHandler"
              >
                {{ $t('step3HoneywellClickHere') }}.
              </span>
            </p>
            <p id="app-login-proceed__text">{{ $t('step3HoneywellContinue') }}</p>
          </template>
        </div>
      </div>
    </div>
    <HoneywellEnrollmentModal
      v-model="showModal"
      :app="appSelected"
    />
    <QuestionOauth
      v-if="appSelected"
      ref="questionOauth"
      :question="oauthQuestion"
      :hostUrl="oauthHostUrl"
      :clientUrl="oauthClientUrl"
      :testMode="false"
      style="display: none;"
    />
  </main>
</template>

<script>
import HoneywellEnrollmentModal from '../Modal/HoneywellEnrollmentModal.vue';
import defaultTheme from '../../styles/defaultTheme';
import Honeywell from '../Device/DeviceQuestionSets/Honeywell';
import QuestionOauth from './QuestionOauth.vue';
import scrollToElement from '../../lib/scrollToElement';

export default {
  name: 'QuestionHoneywellAppEnrollment',
  components: { HoneywellEnrollmentModal, QuestionOauth },
  inject: {
    theme: { default: defaultTheme },
    customer: 'customer',
    program: 'program',
  },
  props: {
    value: {
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      appSelected: this.value || null,
      oauthQuestion: {
        additionalFields: {
          type: this.value || null,
        },
      },
      oauthHostUrl: undefined,
      oauthClientUrl: undefined,
      helpLink: (this.customer.helpLink) || (this.program.programSettings.find(({ key }) => key === 'byodHelp') || this.customer.commonSettings.find(({ key }) => key === 'byodHelp') || { url: 'https://support.virtualpeaker.io' }).url,
    };
  },
  mounted() {
    this.oauthHostUrl = `${window.VP_API_HOST}/byod/house/oauth-device`;
    this.oauthClientUrl = `${window.VP_BYOD_HOST}`;
  },
  methods: {
    handleSelect(val) {
      this.appSelected = val;
      this.$emit('input', val);
      this.oauthQuestion.additionalFields.type = val;
      this.$nextTick(() => {
        const container = this.$el.querySelector('.app-login-info__container');
        if (container) scrollToElement(container, { offsetFromTop: 200 });
      });
    },
    showModalHandler() {
      this.showModal = true;
    },
  },
};
</script>

<style scoped lang="scss">
#honeywellAppEnrollment-question {
  .tile-selector--header,
  .device-tile-content h4 {
    font-size: 24px;
    line-height: 40px;
    font-weight: 400;
  }

  .tile-selector--help {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    margin-bottom: unset;
  }
}

.app-login-info__text {
  margin-top: 27px;

  p {
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 0px;
  }
}

#app-login-proceed__text {
  margin-top: 32px;
  margin-bottom: 8px;
}

.honeywell-add {
  margin-right: auto;
}
</style>
